// The block's markup is serialized from its `innerContent` (static HTML
// fragments interleaved with inner blocks), not from a save implementation.
export default function save() {
	return null;
}
